import { all } from 'redux-saga/effects';

// global store
import client from 'src/store/client/sagas';
import globalView from 'src/store/view/sagas';
import globalAnalytics from 'src/store/analytics/sagas';
import payment from 'src/store/payment/sagas';
import wishlist from 'src/store/wishlist/sagas';
import bannerAppData from 'src/store/appBanners/sagas';
import touristsValidation from 'src/store/touristsValidation/saga';
// common store
import actualization from 'src/routes/Checkout/store/sagas/actualization';
import analytics from 'src/routes/Checkout/store/sagas/analytics';
import commonClient from 'src/routes/Checkout/store/client/saga';
import error from 'src/routes/Checkout/store/sagas/error';
import extraRooms from 'src/routes/Checkout/store/sagas/extra-rooms';
import packageUpsaleOptions from 'src/routes/Checkout/store/domains/package-upsale-options/saga';
import similarPackages from 'src/routes/Checkout/store/sagas/similar-packages';
import tourists from 'src/routes/Checkout/store/sagas/tourists';
import view from 'src/routes/Checkout/store/sagas/view';
import { saga as prebook } from 'src/routes/Checkout/store/domains/package-prebook';
import commonOrder, {
  watchPrebuildOrderRequest,
} from 'checkout/store/sagas/order';
import touristsCheckoutValidation from 'checkout/store/domains/tourists-checkout-validation/saga';

// package sagas
import testimonials from '../testimonials/sagas';
import actualizeAlternatives from '../actualize-alternatives/saga';
import flights from '../flights/saga';
import order from '../order/saga';

function* sagas() {
  yield all([
    client(),
    payment(),
    globalView(),
    globalAnalytics(),
    wishlist(),
    touristsValidation(),
    //
    commonClient(),
    actualization(),
    analytics(),
    commonOrder(),
    error(),
    extraRooms(),
    packageUpsaleOptions(),
    touristsCheckoutValidation(),
    similarPackages(),
    testimonials(),
    tourists(),
    view(),
    prebook(),
    actualizeAlternatives(),
    flights(),
    bannerAppData(),
    watchPrebuildOrderRequest(),
    order(),
  ]);
}

export default sagas;
